import styled, { css } from 'styled-components';
import { Flex } from 'components/Flex';
import { Body, Caption } from 'components/Typography';
import { BKJIcon } from '@bookjane2/bookjane-design-library';

export const TimeOffJaneWrapper = styled.div`
  width: 100%;
`;

export const AvatarIconWrapper = styled.div`
  position: relative;
`;

export const TimeOffJane = styled(Flex)`
  width: 100%;
  padding: 14px 25px;
  background-color: ${({ theme }) => theme.colors.Grey1};
`;

export const TimeOffJaneName = styled(Body)`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const TimeOffJaneFacility = styled(Caption)`
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  ${({ theme }) => theme.common.Ellipsis};
  max-width: 350px;
  @media (max-width: ${({ theme }) => theme.breakpoints.Mobile}) {
    max-width: 240px;
  }
`;

export const TimeOffJaneStyledBKJIcon = styled(BKJIcon)<{
  left: string;
  top: string;
}>`
  position: absolute;
  ${({ left }) =>
    left &&
    css`
      left: ${left}px;
    `};
  ${({ top }) =>
    top &&
    css`
      top: ${top}px;
    `};
`;
